import { queryOptions } from "@tanstack/react-query";
import { api, unwrap } from "@/client/lib/api";

/** Every client by name, every page, once; a picker or a filter searches it in memory. */
export const clientsQuery = queryOptions({
  queryKey: ["clients"],
  queryFn: async () => {
    const rows = [];
    let after: string | undefined;
    do {
      const page = await unwrap(
        api.clients.$get({ query: after ? { after } : {} }),
      );
      rows.push(...page.items);
      after = page.next ?? undefined;
    } while (after);
    return rows.sort((a, b) => a.name.localeCompare(b.name));
  },
});

export type ClientRow = Awaited<
  ReturnType<NonNullable<(typeof clientsQuery)["queryFn"]>>
>[number];

/**
 * An Admin's read: legal name, address, tax ID, email, currency and terms, as the draft it is
 * opened from sees them; that draft does not count among the client's uses.
 */
export const clientBillingQuery = (clientId: string, draftId: string) =>
  queryOptions({
    queryKey: ["clients", clientId, "billing", draftId],
    queryFn: () =>
      unwrap(
        api.clients[":id"].billing.$get({
          param: { id: clientId },
          query: { draft: draftId },
        }),
      ),
  });

export type ClientBilling = Awaited<
  ReturnType<NonNullable<ReturnType<typeof clientBillingQuery>["queryFn"]>>
>;
